import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { DetailPair } from '../../../../../shared/components/detail-info-card/DetailPair';
import { OrgAddressEditDialogComponent } from './org-address-edit-dialog/org-address-edit-dialog.component';
import { Logger } from '../../../../../infrastructure/logging/logger';
import { Country } from '../../../../../shared/address/Country';
import { CountryService } from '../../../../../shared/reference/country.service';
import { getCountryNameFromCountryId } from '../../../../../utilities/CountryUtility';
import { OrganizationService } from '../../../services/organizations.service';
import { DetailInfoCardComponent } from '../../../../../shared/components/detail-info-card/detail-info-card.component';
import { State } from '../../../../../shared/address/State';
import { NotificationService } from '../../../../../utilities/PortalNotificationUtility';

@Component({
  selector: 'app-org-address',
  templateUrl: './org-address.component.html',
  styleUrls: ['./org-address.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinner,
    DetailInfoCardComponent
  ]
})
export class OrgAddressComponent implements OnInit {

  @Input() org: any;
  @Input() embeddedOrganizationBoolean: any;
  @Input() states!: State[];

  userIsSysAdmin: boolean = false;
  loading = new BehaviorSubject<boolean>(false);
  address: DetailPair[] = [];
  countries!: Country[];
  addressAbbreviation: string = '';

  constructor(
    private dialog: MatDialog,
    private countryService: CountryService,
    private organizationService: OrganizationService,
    private logService: Logger,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    if (this.embeddedOrganizationBoolean) {
      this.populateEmbeddedOrgAddress(this.org);
    } else {
      this.retrieveCountries()
      .then(_ => {
        this.populateAddress();
      }).catch(e => {
        this.logService.handleError(e, 'An error occurred while retrieving Organization address', 'Error while retrieving Organization address');
      }).finally(() => {
        this.userIsSysAdmin = true;
      });
    }
  }

  async retrieveCountries() {
    this.loading.next(true);
    try {
      this.countries = await this.countryService.getCountries();
    } catch (e) {
      this.logService.handleError(e, 'An error occurred while retrieving Countries', 'Error while retrieving Countries');
    } finally {
      this.loading.next(false);
    }
  }

  populateAddress() {
    this.address = [];

    const address = this.org.address;
    if (address.state) {
    this.addressAbbreviation = address.state;
      if (address.state.length > 2) {
        let foundState = this.states.find(state => state.label.toLowerCase() === address.state.toLowerCase());
        if (foundState) {
          this.addressAbbreviation = foundState.value;
        }
      }
    }


    this.address.push(new DetailPair("Address Line 1", address.address_line_1))
    this.address.push(new DetailPair("Address Line 2", address.address_line_2))
    this.address.push(new DetailPair("City/Town", address.city))
    this.address.push(new DetailPair("State/Province", this.addressAbbreviation))
    this.address.push(new DetailPair("Postal Code", address.postal_code))
    this.address.push(new DetailPair("Country", getCountryNameFromCountryId(this.countries, address.country_id)))
  }

  populateEmbeddedOrgAddress(partnerOrganization: any) {
    this.address = [];
    this.address.push(new DetailPair("Address Line 1", partnerOrganization.addressLine1))
    this.address.push(new DetailPair("Address Line 2", partnerOrganization.addressLine2))
    this.address.push(new DetailPair("City/Town", partnerOrganization.city))
    this.address.push(new DetailPair("State/Province", partnerOrganization.state))
    this.address.push(new DetailPair("Postal Code", partnerOrganization.postalCode))
    this.address.push(new DetailPair("Country", partnerOrganization.country))
  }

  onEditAddressClick() {
    const dialogRef = this.dialog.open(OrgAddressEditDialogComponent, {
      width: '60%',
      data: {
        addressLine1: this.org.address.address_line_1,
        addressLine2: this.org.address.address_line_2,
        city: this.org.address.city,
        state: this.addressAbbreviation,
        countryId: this.org.address.country_id,
        postalCode: this.org.address.postal_code
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async data => {
      if (data) {
        this.updateOrganizationAddress(data);
        this.org.photo = this.org.logo.photo_url;
        await this.organizationService.updateOrganization(this.org);
        this.populateAddress();
      }
    });
  }

  private updateOrganizationAddress(data: any) {
    this.org.address.address_line_1 = data.addressLine1;
    this.org.address.address_line_2 = data.addressLine2;
    this.org.address.city = data.city;
    this.org.address.state = data.state;
    this.org.address.country_id = data.countryId;
    this.org.address.country_name = getCountryNameFromCountryId(this.countries, data.countryId);
    //this.org.address.country_name = this.countries.find(country => country.id == data.countryId)?.display_text;
    this.org.address.postal_code = data.postalCode;
  }
}